/*
 * @Author: lixiuhuang
 * @Date: 2020-08-24 10:14:13
 * @Last Modified by: lixiuhuang
 * @Last Modified time: 2021-02-25 13:52:45
 */
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const noPage = (resolve) => require(["../404.vue"], resolve);
const Index = (resolve) => require(["../components/index.vue"], resolve);
const Series = (resolve) => require(["../components/series.vue"], resolve);
const seriesMore = (resolve) => require(["../components/seriesMore.vue"], resolve);
const liveSeries = (resolve) => require(["../components/liveSeries.vue"], resolve);
const Play = (resolve) => require(["../components/Play.vue"], resolve);
const Login = (resolve) => require(["../components/login.vue"], resolve);
const user = (resolve) => require(["../components/user.vue"], resolve);
const myCourse = (resolve) => require(["../components/myCourse.vue"], resolve);
const cmtPay = (resolve) => require(["../components/pay.vue"], resolve);
const cmtIntro = (resolve) => require(["../components/intro.vue"], resolve);
const Artful = (resolve) => require(["../components/artful.vue"], resolve);
const CClivePlay = (resolve) => require(["../components/cclivePlay.vue"], resolve);
const jpSeries = (resolve) => require(["../components/jpSeries.vue"], resolve);
const epaper = (resolve) => require(["../components/epaper.vue"], resolve);
const reportpay = (resolve) => require(["../components/reportpay.vue"], resolve);
const digitalreport = (resolve) => require(["../components/digitalreport.vue"], resolve);
//const unittest = (resolve) => require(["../components/unittest.vue"], resolve); //TODO
const unittestNew = (resolve) => require(["../components/unittestNew.vue"], resolve);
//const testresults = (resolve) => require(["../components/testresults.vue"], resolve); //TODO
const testresultsNew = (resolve) => require(["../components/testresultsNew.vue"], resolve);
const bigtmg = (resolve) => require(["../components/bigtmg.vue"], resolve);
const coupon = (resolve) => require(["../components/coupon.vue"], resolve);
const coupon_list_tab = (resolve) => require(["../components/coupon_list_tab.vue"], resolve);
const business_list = (resolve) => require(["../components/business_list.vue"], resolve);
const Meeting = (resolve) => require(["../components/meeting.vue"], resolve);
const MeetingDetail = (resolve) => require(["../components/meetingDetail.vue"], resolve);
const categoryList = (resolve) => require(["../components/cagegory_list.vue"], resolve);
const errorPage = (resolve) => require(["../components/helpPage/error.vue"], resolve);
const classExam = (resolve) => require(["../components/classExam/exam.vue"], resolve);
const classExamResult = (resolve) => require(["../components/classExam/result.vue"], resolve);
const userIdentity = (resolve) => require(["../components/user/userIdentity.vue"], resolve);
const userIdentityApp = (resolve) => require(["../components/user/userIdentityApp.vue"], resolve);
const projectSignup = (resolve) => require(["../components/project/signup.vue"], resolve);  //项目报名的

const ccMergeLive = (resolve) => require(["../components/ccMergeLive.vue"], resolve);//新版合并cc直播
const ccDbPlay = (resolve) => require(["../components/ccDbPlay.vue"], resolve);//新版合并cc点播
const mergePlay = (resolve) => require(["../components/mergePlay.vue"], resolve);//新版合并录播
const generalUnitest = (resolve) => require(["../components/generalUnitest.vue"], resolve);//2024年度大课测试
const generalUnitResult = (resolve) => require(["../components/generalUnitResult.vue"], resolve);//2024年度大课测试
const routes = [
  { path: "/", component: Index },
  { path: "/Series", component: Series },
  { path: "/seriesMore", component: seriesMore },
  { path: "/liveSeries", component: liveSeries },
  { path: "/play", component: Play },
  { path: "/login", component: Login },
  { path: "/user", component: user },
  { path: "/myCourse", component: myCourse },
  { path: "/pay", component: cmtPay },
  { path: "/intro", component: cmtIntro },
  { path: "/artful", component: Artful },
  { path: "/ccliveplay", component: CClivePlay },
  { path: "/jpSeries", component: jpSeries },
  { path: "/epaper", component: epaper },
  { path: "/reportpay", component: reportpay },
  { path: "/digitalreport", component: digitalreport },
  //{ path: "/unittest", component: unittest },
  { path: "/unittestNew", component: unittestNew },
  //{ path: "/testresults", component: testresults },
  { path: "/testresultsNew", component: testresultsNew },
  { path: "/bigtmg", component: bigtmg },
  { path: "/coupon", component: coupon },
  { path: "/coupon_list_tab", component: coupon_list_tab },
  { path: "/business_list", component: business_list },
  { path: "/offline_meeting", component: Meeting },
  { path: "/offline_meeting_detail", component: MeetingDetail },
  { path: "/category-list", component: categoryList },
  { path: "/errorPage", component: errorPage },
  { path: "/classExam/exam", component: classExam },
  { path: "/classExam/result", component: classExamResult },
  { path: "/user/userIdentity/:type/:id", component: userIdentity, name: 'userIdentity' },
  { path: "/user/userIdentityApp/:type/:id", component: userIdentityApp },
  { path: "/project/signup/:pageUuid", component: projectSignup, name: 'projectSignup' },
  { path: "/ccMergeLive",component:ccMergeLive},
  { path: "/ccDbPlay",component:ccDbPlay},
  { path: "/mergePlay",component:mergePlay},
  { path: "/generalUnitest",component:generalUnitest},
  { path: "/generalUnitResult",component:generalUnitResult},
  { path: "*", component: noPage },
];
const router = new Router({
  routes: routes,
});

export default router;



// WEBPACK FOOTER //
// ./src/cmtapp/router/index.js